<template>
  <div :class="'bs-list' + contentClass">
    <el-row
      v-if="isLoading !== true"
      :element-loading-background="
        loading.background || this.$loadingDefault.background
      "
      :element-loading-text="loading.text || this.$loadingDefault.text"
      v-loading="loading.display"
    >
      <slot name="header"></slot>
      <slot
        v-if="result.data.length > 0"
        name="data"
        :data="result.data"
      ></slot>
      <slot v-else-if="loading.display !== true" name="empty"></slot>
      <slot name="footer"></slot>
    </el-row>
    <template v-else>
      <slot name="header"></slot>
      <slot
        v-if="result.data.length > 0"
        name="data"
        :data="result.data"
      ></slot>
      <slot v-else-if="loading.display !== true" name="empty"></slot>
      <slot name="footer"></slot>
    </template>
  </div>
</template>

<style scoped lang="scss"></style>

<script>
import { getList } from "../actions/basis/list";
import { getTreeList } from "../actions/basis/tree";
export default {
  data() {
    return {
      loading: {
        display: false,
        background: null,
        text: null
      },
      result: {
        data: []
      }
    };
  },
  name: "BsList",
  props: {
    routeWatch: {
      type: Boolean,
      default: true
    },
    meta: {
      type: Object,
      module: {
        type: String,
        required: true
      },
      field: {
        type: String,
        required: true
      }
    },
    filter: {
      type: Object
    },
    api: {
      type: String
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    contentClass: {
      type: String
    },
    isInit: {
      type: Boolean,
      default: true
    }
  },
  computed: {},
  components: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    if (this.isInit) {
      this.loadData();
    }
    //父窗口使用 that.$refs["ref"].loadData();
  },
  methods: {
    clearData() {
      this.result.data = [];
    },
    loadData() {
      let that = this;
      that.loading.display = true;
      if (this.isLoading === true) {
        that.$emit("on-load-before", that.loading.display);
      }
      that.result.data = [];
      getTreeList(that.meta.module, that.filter, that.meta.field, that.api).then(
        res => {
          that.loading.display = false;
          if (this.isLoading === true) {
            that.$emit("on-load-after", that.loading.display);
          }
          if (!res) return;
          that.result = res;
          that.$emit("on-data-after", that.result);
        }
      );
    }
  },
  watch: {
    $route: function(to, from) {
      if (this.routeWatch === true) {
      }
    }
  },
  destroyed() {},
  deactivated() {}
};
</script>
